import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { makeValidable, FormInput, InvisibleSubmit } from '@ami/react/core';
import { QuoteProductOverrideDiscount } from '../../otherQuoteEntities';

const FormData = makeValidable(({ overrideDiscount, save, onOverrideDiscountUpdated }) => {
  return (
    <form className="container" onSubmit={save}>
      <div className="row">
        <div className="col-md-9">
          <FormInput
            label="Name"
            value={overrideDiscount.name}
            onChange={e => onOverrideDiscountUpdated({ name: e.target.value })}
            required
          />
        </div>
        <div className="col-md-3">
          <FormInput
            prependValue='%'
            type="number"
            min="0"
            label="Percentage"
            value={overrideDiscount.percentage}
            onChange={(e) => onOverrideDiscountUpdated({ percentage: e.target.value })}
            required
          />
        </div>
      </div>
      <InvisibleSubmit />
    </form>
  );
});

export default class ReviewQuoteProductOverrideDiscountModal extends React.Component {
  constructor(props) {
    super(props);
    this.formDataRef = React.createRef();
  }

  state = {
    show: false,
    showValidations: false,
    overrideDiscount: null,
    quoteProductId: null,
    editMode: false
  };

  static propTypes = {
    onOverrideDiscountCreated: PropTypes.func.isRequired
  };

  addOverrideDiscountFor(quoteProductId) {
    this.setState({
      show: true,
      showValidations: false,
      overrideDiscount: new QuoteProductOverrideDiscount(),
      quoteProductId
    });
  }

  editOverrideDiscountFor(quoteProductId, overrideDiscount) {
    this.setState({
      show: true,
      showValidations: false,
      overrideDiscount: new QuoteProductOverrideDiscount(overrideDiscount),
      quoteProductId
    });
  }

  updateOverrideDiscount = updateObject => {
    this.setState({
      overrideDiscount: Object.assign(
        new QuoteProductOverrideDiscount(this.state.overrideDiscount),
        updateObject
      )
    });
  };

  hide = () => this.setState({ show: false });

  save = (e) => {
    if (e) e.preventDefault();
    this.setState({ showValidations: true }, () => {
      if (!this.formDataRef.current.isValid()) {
        return;
      }

      const { quoteProductId, overrideDiscount } = this.state;
      this.props.onOverrideDiscountCreated(quoteProductId, overrideDiscount);
      this.hide();
    });
  };

  render() {
    const { overrideDiscount, show, editMode, showValidations } = this.state;
    if (!show) return null;
    const title = `${editMode ? 'Edit' : 'Add'} Override Discount`;
    return (
      <SimpleModal show={show} size="lg">
        <ModalHeader title={title} />
        <ModalBody>
          <FormData
            overrideDiscount={overrideDiscount}
            save={this.save}
            onOverrideDiscountUpdated={this.updateOverrideDiscount}
            ref={this.formDataRef}
            showValidations={showValidations}
          />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={this.save}>
            Save
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
